const customStyles = {
  headCells: {
    style: {
      backgroundColor: "rgb(29, 138, 148)",
      color: "white"
    },
  },
}

export default customStyles